import React, {Component} from 'react'
import { withRouter } from 'react-router-dom'
import asyncWrapper from '../../../../../shared/javascripts/hocs/asyncWrapper'
import { Panel } from 'react-bootstrap'
import Loading from '../../../../../shared/javascripts/components/Loading'
import LoadingError from '../../../../../shared/javascripts/components/LoadingError'
import MonitoringApi from '../../api/MonitoringApi'
import ServerPanel from './ServerPanel'
import DataPanel from './DataPanel'

class TabContent extends Component {
  componentDidMount() {
    MonitoringApi.statuses('consumerApi')
      .then(this.props.handleErrors)
      .then(response => {
        this.props.saveConsumerApiData(response)
      }).then(() => this.props.setLoading()).catch(error => console.log(error))
  }

  render() {
    if(this.props.loading) { return <Loading />}
    const consumerApiData = this.props.consumerApiData;
    if(consumerApiData.error || consumerApiData.data.source_error) {return <LoadingError message={consumerApiData.error || consumerApiData.data.source_error} />}
    return(
      <div className='TabContent'>
        <ServerPanel data={consumerApiData.data} />
        <DataPanel data={consumerApiData.data} />
      </div>
    )
  }
}

export default asyncWrapper(withRouter(TabContent))


// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/components/ConsumerApi/TabContent.jsx